export default ":host{display:inline-block;width:80px;height:80px}.odep-e-icon__svg{display:inline-block;width:100%;height:100%;fill:inherit;stroke:inherit}\n";